import React from "react";
import Analysis from "../../assets/service/how-it-works-1.png";
import Adjjustment from "../../assets/service/how-it-works-2.png";
import Nutrition from "../../assets/service/how-it-works-3.png";
import Conventional from "../../assets/service/how-it-works-4.png";
import GreenChecked from "../../assets/green-check.svg";

const MainSection = () => {
  const stepsData = [
    {
      id: 1,
      step: "STEP 1",
      title: "Spot the Trend with",
      highlight: "InsightSuite",
      description:
        "InsightSuite™ scans millions of reviews and posts to identify unmet needs, fast-rising flavors, and whitespace you can own. It's your starting point for de-risked innovation.",
      image: Analysis,
      listItems: [
        "Surface real-time consumer sentiment",
        "Full fledge unique and reliable functionality",
        "Eliminate guesswork in product ideation",
      ],
      imageLeft: true,
      highlightTop: false,
    },
    {
      id: 2,
      step: "STEP 2",
      title: "Slower",
      highlight: "Plan Smarter",
      description:
        "InsightSuite™ helps size the prize, map functional claims, and run cost models—all before you spend a dollar on development.",
      image: Adjjustment,
      listItems: [
        "Model cost-per-unit instantly",
        "Align claims with demand data",
        "Save time and avoid missteps early",
      ],
      imageLeft: false,
      highlightTop: true,
    },
    {
      id: 3,
      step: "STEP 3",
      title: "Compliance Chaos",
      highlight: "Clean up the",
      description:
        "RegulateCPG auto-validates every ingredient, claim, and region, then generates compliant nutrition panels and export-ready docs in seconds.",
      image: Nutrition,
      listItems: [
        "Built-in rule logic for every region",
        "Auto-generate Nutrition Facts and ingredient statements",
        "Eliminate manual entry and spreadsheets",
      ],
      imageLeft: true,
      highlightTop: true,
    },
    {
      id: 4,
      step: "STEP 4",
      title: "80% Faster from",
      highlight: "Concept to Consumer",
      description:
        "With InsightSuite™ guiding what to make and RegulateCPG ensuring it’s retail-ready, you launch faster—without compromising on safety or accuracy.",
      image: Conventional,
      listItems: [
        "Reduce launch timeline by up to 80%",
        "Reach 96% labeling accuracy",
        "Stay audit-ready and aligned across teams",
      ],
      imageLeft: false,
      highlightTop: false,
    },
  ];

  return (
    <div className="howItWork d-flex justify-content-center">
      <div className="service_container section-container ">
        <div>
          <h2 className="title text-center">How It Works</h2>
          <p
            className="large normal off-black text-center"
            style={{ opacity: "0.6" }}
          >
            See what consumers actually want with Insightsuite™ & execute with
            RegulateCPG
          </p>
        </div>

        {stepsData.map((step, index) => (
          <div key={step?.id} className="workSection">
            <div className=" worSectionRow">
              {/* Image on Left */}
              {step.imageLeft && (
                <div>
                  <img src={step.image} className="imageSec" alt="img" />
                </div>
              )}

              <div
                className={`contentDesc ${step.imageLeft ? "pr-40" : "pl-40"}`}
              >
                <div>
                  <p className="step deep-blue">{step.step}</p>

                  {!step?.highlightTop && (
                    <>
                      <h2 className={`title mt-20px `}>{step.title}</h2>
                      <h2 className={`title`}>
                        <span className="green-accent">{step.highlight}</span>
                        {step?.id === 1 && (
                          <span style={{ fontWeight: "200" }}>™</span>
                        )}
                      </h2>
                    </>
                  )}

                  {step?.highlightTop && (
                    <>
                      <h2 className={`title mt-20px`}>
                        <span className="green-accent">{step.highlight}</span>
                        {step?.id === 2 && (
                          <>
                            <span
                              style={{
                                color: "var( --Off-Black)",
                              }}
                            >
                              ,
                            </span>

                            <span
                              style={{
                                color: "var( --Off-Black)",
                                paddingLeft: "8px",
                              }}
                            >
                              Not
                            </span>
                          </>
                        )}
                      </h2>
                      <h2 className={`title`}>{step.title}</h2>
                    </>
                  )}

                  <p className="text mt-20px ">{step.description}</p>
                  <div className="mt-40px">
                    <ul className="listStyle">
                      {step.listItems.map((item, idx) => (
                        <li key={idx} style={{ display: "flex" }}>
                          <div>
                            <img
                              src={GreenChecked}
                              alt="checkbox"
                              className="checkboxImage"
                            />
                          </div>
                          <p style={{ marginLeft: ".625rem", opacity: "0.6" }}>
                            {item}
                          </p>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              {/* Image on Right */}
              {!step.imageLeft && (
                <div>
                  <img src={step.image} className="imageSec" alt="img" />
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MainSection;
